import React, { Component } from 'react';
import { FaInfoCircle } from 'react-icons/fa';
import { connect } from 'react-redux';
import axios from '../../../../axios-local-api';
import Confirm from '../../../../components/UI/Confirm/Confirm';
import Error from '../../../../components/UI/Error/Error';
import Input from '../../../../components/UI/Input/Input';
import Modal from '../../../../components/UI/Modal/Modal';
import Spinner from '../../../../components/UI/Spinner/Spinner';
import Success from '../../../../components/UI/Success/Success';
import Box from '../../../../hoc/Box/Box';
import withErrorHandler from '../../../../hoc/withErrorHandler/withErrorHandler';
import { checkValidity, updateObject } from '../../../../shared/utility';
import * as actions from '../../../../store/actions/index';
import classes from './ChangePortAssignment.css';

class ChangePortAssignment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      adding: false,
      success: false,
      error: false,
      action: null,
      refreshLogs: false,
      confirmModal: false,
      originalPortAssignment: this.props.originalPortAssignment,
      changeForm: {
        name: {
          elementType: 'input',
          elementConfig: {
            id: 'ChangePortName',
            type: 'text',
            placeholder: '(3-20 characters)',
          },
          value: this.props.originalPortAssignment.name,
          validation: {
            required: true,
            minLength: 3,
          },
          valid: true,
          touched: false,
          label: 'Name',
        },
        externalPort: {
          elementType: 'input',
          elementConfig: {
            type: 'text',
            placeholder: '(0-65535 port numbers)',
          },
          disabled: true,
          value: this.props.originalPortAssignment.externalPort,
          validation: {
            maxLength: 0,
          },
          valid: false,
          touched: false,
          label: 'External Port',
        },
        internalPort: {
          elementType: 'input',
          elementConfig: {
            id: 'InternalPort',
            type: 'text',
            placeholder: '(1-65535 port numbers)',
          },
          value: this.props.originalPortAssignment.internalPort,
          validation: {
            required: true,
            maxLength: 5,
          },
          valid: true,
          touched: false,
          label: 'Internal Port',
        },

        protocol: {
          elementType: 'select',
          elementConfig: {
            type: 'text',
            placeholder: 'Protcol (udp, tcp)',
            options: [
              { value: 'tcp', displayValue: 'TCP' },
              { value: 'udp', displayValue: 'UDP' },
              { value: 'tcp+udp', displayValue: 'TCP+UDP' },
            ],
          },
          value: this.props.originalPortAssignment.protocol,

          validation: {
            required: true,
          },
          valid: true,
          touched: false,
          label: 'Protocol',
        },
      },
      formIsValid: false,
    };
  }
  componentWillMount() {}
  componentDidMount() {}
  componentWillUpdate() {}
  componentDidUpdate() {}
  successErrorResetHandler = () => {
    this.setState({ error: false, success: false });
    this.props.onResetPortErrorSuccess();
  };

  confirmModalCancelHandler = () => {
    this.setState({ confirmModal: false });
    this.props.onCancel();
  };

  submitDeletePortAssignmentHandler = (event) => {
    const formVals = {
      name: this.state.changeForm.name.value,
      internalPort: this.state.changeForm.internalPort.value,
      protocol: this.state.changeForm.protocol.value,
      originalPortAssignment: this.props.originalPortAssignment,
    };
    this.props.onSubmit(
      'remove this Port from your IP Reservations',
      formVals,
      true
    );
  };

  changeFormHandler = (event) => {
    const formVals = {
      name: this.state.changeForm.name.value,
      internalPort: this.state.changeForm.internalPort.value,
      protocol: this.state.changeForm.protocol.value,
      originalPortAssignment: this.props.originalPortAssignment,
    };
    this.props.onSubmit('change this IP reservation', formVals, false);
    // this.props.onOpenModal('change this IP Reservation')
  };

  inputChangedHandler = (event, inputIdentifier) => {
    const updatedFormElement = updateObject(
      this.state.changeForm[inputIdentifier],
      {
        value: event.target.value,
        valid: checkValidity(
          event.target.value,
          this.state.changeForm[inputIdentifier].validation
        ),
        touched: true,
      }
    );
    const updatedChangePortAssignment = updateObject(this.state.changeForm, {
      [inputIdentifier]: updatedFormElement,
    });

    let formIsValid = true;
    for (let inputIdentifier in updatedChangePortAssignment) {
      formIsValid =
        updatedChangePortAssignment[inputIdentifier].valid && formIsValid;
    }
    this.setState({
      changeForm: updatedChangePortAssignment,
      formIsValid: formIsValid,
    });
  };

  isValidForm() {
    const nameValue = this.state.changeForm.name.value || '';
    if (nameValue.trim().length <= 2) return false;

    if (nameValue.trim().length > 20) return false;

    if (this.state.changeForm.internalPort.value.length < 1) return false;

    if (/^0/.test(this.state.changeForm.internalPort.value)) return false;

    const reg = /^\d+$/;
    if (!reg.test(this.state.changeForm.internalPort.value)) return false;

    let port = parseInt(this.state.changeForm.internalPort.value, 10);
    if (port < 1) return false;

    if (port > 65535) return false;
    // === checks equality of value and type. The port number of changeform is string. In order to use ===, we must convert it into integer first.
    if (
      this.props.originalPortAssignment.name.trim() ===
        this.state.changeForm.name.value.trim() &&
      this.props.originalPortAssignment.internalPort === port &&
      this.props.originalPortAssignment.protocol ===
        this.state.changeForm.protocol.value
    )
      return false;

    return true;
  }

  render() {
    if (this.props.error && !this.state.error) {
      this.setState({ error: true });
      this.props.onResetDhcpErrorSuccess();
    }
    if (this.props.success && !this.state.success) {
      this.setState({ success: true });
      this.props.onResetDhcpErrorSuccess();
    }

    const formElementsArray = [];
    for (let key in this.state.changeForm) {
      formElementsArray.push({
        id: key,
        config: this.state.changeForm[key],
      });
    }

    let form = (
      <form style={{ display: 'inline' }}>
        {formElementsArray.map((formElement) => (
          <Box>
            <div style={{ margin: '10px 0px -20px 10px', color: 'black' }}>
              {formElement.config.label}
            </div>
            <div className={classes.InnerBodyRow}></div>
            <div className={classes.inputClass}>
              <Input
                key={formElement.id}
                elementType={formElement.config.elementType}
                elementConfig={formElement.config.elementConfig}
                value={formElement.config.value}
                invalid={!formElement.config.valid}
                disabled={formElement.config.disabled}
                shouldValidate={formElement.config.validation}
                touched={formElement.config.touched}
                changed={(event) =>
                  this.inputChangedHandler(event, formElement.id)
                }
              />
            </div>
          </Box>
        ))}

        <div style={{ color: 'black', margin: '10px', display: 'flex' }}>
          <span id ='changePortMsgIcon'>
            <FaInfoCircle color="orange" />
          </span>
          <span id ='changePortMsg' style={{ marginLeft: '10px' }}>
            Change may take up to 2-10 minutes to occur on the customer router and public IP address may change. <b>During this time, the customer network may reboot.</b>
          </span>
        </div>
      </form>
    );

    if (this.props.loading) {
      form = <Spinner />;
    }

    return (
      <Box>
        <div className={classes.ChangePortAssignment}>
          <span
            onClick={this.confirmModalCancelHandler}
            style={{ float: 'right', color: 'gray', cursor: 'pointer' }}
          >
            X
          </span>
          <h3 style={{ marginLeft: '10px', margin: '10px 0px 11px 10px' }}>
            Manage Port Assignment
          </h3>
          {form}
          <div style={{ margin: '20px 10px 10px 10px' }}>
            <button
              id="deleteport"
              className={classes.TrashButton}
              onClick={this.submitDeletePortAssignmentHandler}
            >
              Delete{' '}
            </button>
            <button
              className={classes.SaveBtn}
              id="saveport"
              btnType="Success"
              disabled={!this.isValidForm()}
              onClick={this.changeFormHandler}
            >
              Save
            </button>
          </div>
        </div>

        <Modal
          show={this.state.confirmModal}
          modalClosed={this.confirmModalCancelHandler}
        >
          <Confirm
            id={'PortAssignmentConfirm'}
            confirm={this.confirmModalConfirmHandler}
            cancel={this.confirmModalCancelHandler}
            action={`Are you sure you want to ${this.state.action}?`}
            deviceGroupConfirmation
          />
        </Modal>
        <Modal
          show={this.state.error}
          modalClosed={this.successErrorResetHandler}
        >
          <Error />
        </Modal>
        <Modal
          show={this.state.success}
          modalClosed={this.successErrorResetHandler}
        >
          <Success />
        </Modal>
      </Box>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adding: false,
    refreshLogs: true,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onResetDhcpErrorSuccess: () => dispatch(actions.resetDhcpErrorSuccess()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withErrorHandler(ChangePortAssignment, axios));
